import React from 'react'

const BenefitDetails = () => {
  return (
    <div>BenefitDetails</div>
  )
}

export default BenefitDetails